import { quickExit } from '../lib/quickExit';

/**
 * Sidebar box above "Got an idea?", same shape. Deliberately calm — an
 * alarming red button would itself draw the eye of whoever's looking.
 * Behaviour and the Esc-Esc shortcut live in lib/quickExit.js.
 */
export const QuickExitBox = () => (
  <div className="mt-6 rounded-[12px] bg-inset p-4">
    <p className="text-[15px] font-semibold text-ink">Need to leave quickly?</p>
    <p className="mt-1 text-[13px] leading-snug text-ink-55">
      Or press Esc twice.
    </p>
    <button
      type="button"
      onClick={quickExit}
      className="mt-2 inline-block text-[13px] font-semibold text-brand hover:underline"
      data-testid="quick-exit-btn"
    >
      Sign out and leave
    </button>
  </div>
);

export default QuickExitBox;
